
function checkSpace(el, { value, modifiers }, vnode) {
  try {
    //此处可以debug看看el具体值是什么,这里演示的是原生控件input,如果是使用element中的<el-input />标签,需要通过 el.children[0] 拿到原生input.
    let len  = el.children.length-1;
    //获取input元素
    el = el.children[len];
    // console.log(el,el.value,"el.value===");
    if (!el.value) {
      return false;
    }
    el.value = el.value.replace(/\s+/g, "");
    el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
  } catch (e) {
  }

}

export default {
  update(el, { value, modifiers }, vnode) {
    checkSpace(el, { value, modifiers }, vnode)
  }
}
